import React from 'react';
import styles from './empty-couples.module.scss';
import { Button, Typography } from '@/ui-kit';
import { MessageIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';
import { useTranslation } from 'react-i18next';

interface Props {}

export const EmptyCouples: React.FC<Props> = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.icon}>
                <MessageIcon
                    width={28}
                    height={28} />
            </div>
            <Typography
                fontWeight="semibold"
                center
                fontFamily="SFProText"
                className={styles.title}>
                {t('msgs.empty_chats')}
            </Typography>
            <Typography
                center
                fontFamily="SFProText"
                className={styles.text}>
                {t('msgs.empty_couples_note')}
            </Typography>
            <Button
                className={styles.button}
                typeColor="orange"
                isLink
                to={routesApp.browse}>
                {t('find_a_pair')}
            </Button>
        </div>
    );
};
